import React, {useState, useEffect, useCallback, useRef} from "react";
import {useDataContext} from "../../../../services/data.service";
import CollapsePane from "../Core/CollapsePane";
import axios from "axios";
import {API_URL} from "../../../../services/api.service";
import {isEqual} from "lodash";

const ObjectValidationPanel = ({checkChanged}) => {
    const {
        token,
        objectTypes,
        currentRecord,
    } = useDataContext();

    const [imageObjects, setImageObjects] = useState(null);
    const [initialImageObjects, setInitialImageObjects] = useState(null);
    const abortControllerRef = useRef(null);

    const getImageObjects = useCallback(async (imageId, signal) => {
        const response = await axios.get(`${API_URL}/images/${imageId}/objects`, {
            headers: {
                "Authorization": `Bearer ${token}`
            },
            signal
        });
        return response.data;
    }, [token]);

    const initialize = useCallback(async () => {
        if (abortControllerRef.current) {
            abortControllerRef.current.abort();
        }

        abortControllerRef.current = new AbortController();
        const signal = abortControllerRef.current.signal;
        try {
            const data = await getImageObjects(currentRecord.id, signal);

            setImageObjects(data.object_statuses);
            setInitialImageObjects(data.object_statuses);
        } catch (error) {
            if (!axios.isCancel(error)) {
                console.error("Failed to fetch image objects:", error);
            }
        }
    }, [currentRecord, getImageObjects]);

    useEffect(() => {
        if (currentRecord) {
            setImageObjects(null);
            setInitialImageObjects(null);
            initialize();
        }

        return () => {
            if (abortControllerRef.current) {
                abortControllerRef.current.abort();
            }
        };
    }, [currentRecord, initialize]);

    const handleCheckChanged = (typeId, objectId, val) => {
        const newState = { ...imageObjects };
        newState[typeId] = { ...newState[typeId] };
        newState[typeId][objectId] = { ...newState[typeId][objectId], exists: val };

        setImageObjects(newState);
        // Notify parent
        checkChanged?.(newState, !isEqual(newState, initialImageObjects));
    }

    const ready = !!objectTypes && !!currentRecord && !!imageObjects;

    return (
        !ready ? <div>Loading, please wait...</div> : <div className="p-3">
            {objectTypes
                .sort((a, b) => a.name > b.name).filter(x => x.name !== "Core Objects")
                .map((objectType) => <CollapsePane key={objectType.id} objectType={objectType} data={imageObjects[objectType.id]} checkChanged={handleCheckChanged}/>)}
        </div>
    )
};

export  default ObjectValidationPanel;
